import React, {useMemo} from 'react';
import {useSelector} from 'react-redux';

import {Group} from '@pb/kit-component-group';
import {Icons} from '@pb/kit-component-icon';
import {BasicIconButton} from '@pb/kit-component-icon-button';
import Loading, {Types} from '@pb/kit-component-loading';
import {Tooltip} from '@pb/kit-component-popups';

import {COLUMNS, HEADERS} from '../constants';
import {useGetGroupsTabMembers} from '../hooks/useGetGroupsTabMembers';
import {groupsTabResultSelector} from '../slices/groups-tab.slice';

type Props = {
    groupIds: number[],
    totalCount: number,
};

const MembersHeaderController = ({groupIds, totalCount}: Props) => {
    const {isLoading, loadingError} = useGetGroupsTabMembers({groupIds, totalCount});

    const contentBefore = useMemo(() => {
        if (isLoading) {
            return <Loading type={Types.ICON}/>;
        }

        if (loadingError) {
            return (
                <Tooltip anchor={({anchorRef, getAnchorProps}) => (
                    <BasicIconButton
                        ref={anchorRef}
                        {...getAnchorProps()}
                        iconProps={{type: Icons.ERROR}}
                    />
                )}>
                    {loadingError.message}
                </Tooltip>
            );
        }

        return undefined;
    }, [isLoading, loadingError]);

    return (
        <Group>
            {contentBefore}
            <strong>{HEADERS[COLUMNS.MEMBERS]}</strong>
        </Group>
    );
};

export const MembersHeader = () => {
    const result = useSelector(groupsTabResultSelector);

    return result ? (
        <MembersHeaderController
            groupIds={result.data.map(({groupId}) => groupId || 0).filter(Boolean)}
            totalCount={result.totalCount}
        />
    ) : (
        <Group>
            <Loading type={Types.ICON}/>
            <strong>{HEADERS[COLUMNS.MEMBERS]}</strong>
        </Group>
    );
};
